module.exports = __webpack_public_path__ + "static/media/document-add.54146f09.svg";